

import type {
    TAllAvailableOperatorsForDisplay,
    TSupportedOperators,
} from "@buzzwaretech/types";

/**
 * Result type for operator conversion
 */
export type TOperatorForPayload = {
  operator: TSupportedOperators;
  isNegation: boolean;
};

/**
 * Converts a display operator to the format needed for supported by filter expression condition.
 * @param displayOperator - The operator from the UI
 * @returns Object with supported operator and negation flag
 */
export const getOperatorForPayload = (
  displayOperator: TAllAvailableOperatorsForDisplay,
): TOperatorForPayload => {
  const isNegation = false;
  const operator = displayOperator;

  return {
    operator,
    isNegation,
  };
};
